module.exports = __webpack_public_path__ + "static/media/ProfileIconPlaceholder.3b310e82.svg";